import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "spinner", "text"]

  enrichData(event) {
    event.preventDefault()
    
    if (this.isEnriching) return
    
    this.isEnriching = true
    this.showLoadingState()
    
    // Get the company ID from the form or URL
    const companyId = this.getCompanyId()
    if (!companyId) {
      this.showError("Company ID not found")
      return
    }
    
    // Make the enrichment request
    this.makeEnrichmentRequest(companyId)
  }

  getCompanyId() {
    // Try to get company ID from various sources
    const urlMatch = window.location.pathname.match(/\/companies\/([^\/]+)/)
    if (urlMatch) return urlMatch[1]
    
    // Check for hidden field in form
    const hiddenField = document.querySelector('input[name="company[id]"]')
    if (hiddenField) return hiddenField.value
    
    return null
  }

  async makeEnrichmentRequest(companyId) {
    try {
      const response = await fetch(`/companies/${companyId}/enrich_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      if (response.ok) {
        // Redirect will happen automatically
        window.location.href = response.url
      } else {
        this.showError("Enrichment request failed")
      }
    } catch (error) {
      console.error('Enrichment error:', error)
      this.showError("Network error during enrichment")
    } finally {
      this.hideLoadingState()
      this.isEnriching = false
    }
  }

  showLoadingState() {
    const button = this.buttonTarget || document.getElementById('enrich-data-btn')
    const spinner = this.spinnerTarget || document.getElementById('enrich-spinner')
    const text = this.textTarget || document.getElementById('enrich-text')
    
    if (button) {
      button.disabled = true
      button.classList.add('opacity-50', 'cursor-not-allowed')
    }
    
    if (spinner) {
      spinner.classList.remove('hidden')
    }
    
    if (text) {
      text.textContent = 'Enriching...'
    }
  }

  hideLoadingState() {
    const button = this.buttonTarget || document.getElementById('enrich-data-btn')
    const spinner = this.spinnerTarget || document.getElementById('enrich-spinner')
    const text = this.textTarget || document.getElementById('enrich-text')
    
    if (button) {
      button.disabled = false
      button.classList.remove('opacity-50', 'cursor-not-allowed')
    }
    
    if (spinner) {
      spinner.classList.add('hidden')
    }
    
    if (text) {
      text.textContent = 'Enrich Data'
    }
  }

  showError(message) {
    // Create error notification
    const notification = document.createElement('div')
    notification.className = 'fixed top-4 right-4 z-50 max-w-sm w-full bg-red-50 shadow-lg rounded-lg pointer-events-auto ring-1 ring-red-200 overflow-hidden'
    notification.innerHTML = `
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <svg class="h-6 w-6 text-red-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-red-800">${message}</p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button class="bg-red-50 rounded-md inline-flex text-red-400 hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" onclick="this.parentElement.parentElement.parentElement.remove()">
              <span class="sr-only">Close</span>
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    `
    
    document.body.appendChild(notification)
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove()
      }
    }, 5000)
  }
}
